
import styled from "styled-components";
import  {
    MdKeyboardArrowRight as Arrowright,
    MdArrowForward as Arrowforward
} from 'react-icons/md';

export const ImgWrap = styled.div`
    max-width: 555px;
    width: 100%;
    height: 100%;
    align-items: center;

    @media (max-width: 768px) {
        max-width: 100%;
    }
`;

export const Img = styled.img`
    width: 100%;
    max-width: 100%;
    margin: 0 0 10px 0;
    align-items: center;
    padding-right: 0;
    display: block;
`;
export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`;
export const ArrowForward = styled(Arrowforward)`
    margin-left: 8px;
    font-size: 20px;
`;

export const ArrowRight = styled(Arrowright)`
    margin-left: 8px;
    font-size: 20px;
`;